import axios from 'axios';
import { TreePlantationUrl, TreePlantationCertificateUrl, PlantationUrl, TreeBannersUrl } from '../url';
import { getToken, getTokenHeader } from '../../../../../v3/Common/Token';
import { toast } from 'react-toastify';

export const getTreePlantationAction = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${TreePlantationUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => next(data))
      .catch((err) => next({ error: err }));
  });
};

export const getTreeBannersAction = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${TreeBannersUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => next(data))
      .catch((err) => next({ error: err }));
  });
};

export const getPlantationAction = async (plantation_id) => {
  return new Promise(async (next) => {
    await axios
      .get(`${PlantationUrl()}?tree_id=${plantation_id}`)
      .then(async ({ data }) => next(data))
      .catch((err) => next({ error: err }));
  });
};

export const downloadTreeCertificateAction = async (tree_id) => {
  try {
    let token = await getToken();
    const response = await fetch(
      `${TreePlantationCertificateUrl()}?tree_id=${tree_id}`,
      { method: 'GET', ...getTokenHeader(token) }
    );
    const blob = await response.blob();
    if (blob.type.includes('application/json')) {
      toast.error('No certificate found');
      return;
    }
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tree_certificate_${tree_id}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    toast.error('Failed to download certificate');
  }
};
